import actions from './actions';
import api, { modelName } from './api';
import CRM_MAIL_STATUS from '../../../constants-v2/crm/crm-mail-status';
import column from '../../abstract/column';
import vars from '../../abstract/vars';

export const sentStatusOptions = {
  SENT: {
    label: 'Nieprzeczytane',
    value: CRM_MAIL_STATUS.SENT,
    color: 'success',
  },
  READ: {
    label: 'Przeczytane',
    value: CRM_MAIL_STATUS.READ,
    color: 'primary',
  },
};


export default {
  actions,
  topRightActions: {},
  api,
  modelName,
  sidebarData: {
    receiver_staff_name: column({
      label: 'Odbiorca - pracownik',
      size: 100,
      format: item => {
        return item?.receiver_staff_name || '-';
      },
    }),
    receiver_staff_email: column({
      label: 'Adres email odbiorcy - pracownik',
      size: 100,
      format: item => {
        return item?.receiver_staff_email || '-';
      },
    }),
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    id: column({ label: 'ID', primary: true, grid: false }),
    sender: column({
      label: 'Nadawca',
      format: item => {
        if(item?.sender_staff_company !== undefined && item?.sender_staff_company !== null) {
          return item?.sender_name + ' ' + item?.sender_email + ' - ' + item?.sender_staff_company || '-';
        }
        return item?.sender_name + ' ' + item?.sender_email || '-';
      },
    }),
    mail_title: column({
      label: 'Tytuł',
    }),
    sent_at: column({
      label: 'Data otrzymania',
    }),
    status: column({
      label: 'Status przeczytania',
      options: sentStatusOptions,
      component: 'value-status',
    }),
  },
  vars: vars({
    noItemsText: 'Brak maili',
    sidebarLabel: 'Podgląd maila',
  }),
};
